import { Environment, Result } from '@standardnotes/snjs';
import { c } from 'ttag';
import { RouteType } from '@standardnotes/ui-services';
export class LoadPurchaseFlowUrl {
    constructor(application, _getPurchaseFlowUrl) {
        this.application = application;
        this._getPurchaseFlowUrl = _getPurchaseFlowUrl;
    }
    async execute() {
        var _a;
        const urlResult = await this._getPurchaseFlowUrl.execute();
        if (urlResult.isFailed()) {
            return urlResult;
        }
        const url = urlResult.getValue();
        const route = this.application.routeService.getRoute();
        const params = route.type === RouteType.Purchase ? route.purchaseParams : { period: null, plan: null };
        const period = params.period ? `&period=${params.period}` : '';
        const plan = params.plan ? `&plan=${params.plan}` : '';
        if (url) {
            const finalUrl = `${url}${period}${plan}`;
            if (this.application.isNativeMobileWeb()) {
                this.application.mobileDevice.openUrl(finalUrl);
            }
            else if (this.application.environment === Environment.Desktop) {
                (_a = this.application.desktopDevice) === null || _a === void 0 ? void 0 : _a.openUrl(finalUrl);
            }
            else {
                const windowProxy = window.open('', '_blank');
                windowProxy.location = finalUrl;
            }
            return Result.ok();
        }
        return Result.fail(c('B7.FilesSubscriptionHelp.Subscription.Error').t `Could not load purchase flow URL.`);
    }
}
